import { all, fork } from 'redux-saga/effects';
import watchLanguageSaga from '../screens/language/saga'
import watchSharedSaga from '../shared/saga'

export default function* root() {
  yield all([
    fork(watchLanguageSaga),
    fork(watchSharedSaga)
  ]);
}